import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ExpoRouterDemoScreen = (params: ExpoRouterDemoScreenProps) => {
  const {
    children,
    centered = true,
    backgroundColor = theme.colors.APP_BACKGROUND,
  } = params;

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerDynamicStyles = useStyle(
    () => ({ backgroundColor }),
    [backgroundColor],
  );

  const containerStyles = [
    styles.container,
    centered && styles.containerCentered,
    containerDynamicStyles,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: theme.spacing['4'],
  },
  containerCentered: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ExpoRouterDemoScreenProps = Readonly<{
  children: ReactNode;
  centered?: boolean;
  backgroundColor?: string;
}>;
